import { render } from "./user-filters.vue?vue&type=template&id=b37e0fc8&scoped=true"
import script from "./user-filters.vue?vue&type=script&lang=js"
export * from "./user-filters.vue?vue&type=script&lang=js"

import "./user-filters.vue?vue&type=style&index=0&id=b37e0fc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37e0fc8"]])

export default __exports__